export const initState = {
  clientInvoices: [],
  isLoaded: false,
  isEmpty: false,
  listener: () => {},
}
